<template>
  <Dialog :visible="visible" @update:visible="e => { visible = e }">
    <div class="confirm-container">
      <div v-if="title" class="confirm-title">{{ title }}</div>
      <div class="confirm-content">{{ content }}</div>
      <div class="confirm-footer">
        <x-button type="default" @click="close">取消</x-button>
        <x-button type="primary" :disabled="loading" @click="handleConfirm">
          <div style="display: flex;align-items: center;justify-content: center;gap: 5px;">
            <LoadingIcon v-if="loading" />
            <span>确定</span>
          </div>
        </x-button>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from '@/components/Dialog/Index.vue'
import { XButton } from '@lx-frontend/cvux'
import LoadingIcon from '../Loading/LoadingIcon.vue'

export default {
  components: {
    XButton,
    Dialog,
    LoadingIcon
  },
  data() {
    return {
      visible: false,
      title: '',
      content: '',
      loading: false,
      onConfirm: () => {}
    }
  },
  methods: {
    open({ title = '提示', content, onConfirm }) {
      this.visible = true
      this.loading = false
      this.title = title
      this.content = content
      this.onConfirm = onConfirm
    },
    close() {
      this.visible = false
    },
    async handleConfirm() {
      try {
        if (this.loading) return
        this.loading = true
        const res = await Promise.resolve(this.onConfirm())
        if (res === false) return
        this.close()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../stylesheets/base/fn.less';

.confirm {
  &-container {
    max-width: 640/@w2;
    width: 640/@w2;
    background: #fff;
    border-radius: 16/@w2;
    padding: 40/@w2;
    box-sizing: border-box;
  }

  &-title {
    font-size: 34/@w2;
    line-height: 48/@w2;
    font-weight: bold;
    text-align: center;
  }

  &-content {
    font-size: 30/@w2;
    color: #333;
    line-height: 1.5;
    padding: 40/@w2 0;
    text-align: center;
    word-break: break-all;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    .gap-x(20/@w2);

    /deep/ .weui_btn {
      font-size: 30/@w2;
    }
  }

}
</style>
